<template>
    <div>
        <div class="homelist">
            <img src="@/images/userbk@3x.png"/>
            <div class="homeinfo">
                <template>
                    <img :src="list.avatarurl" />
                </template>
                <template>{{list.nickname}}</template>
            </div>
            <div class="homebody">
                <div class="page-container-margin">
                    <router-link to="/myregister" class="hrefitem">
                        <div class="linell">
                            <div>
                                <img src="@/images/register.png" class="mvicon"/>
                            </div>
                            <div >
                                <div>我的报名</div>
                                <img src="@/images/chevron@3x.png" class="access"/>
                            </div>
                        </div>
                    </router-link>
                    <router-link to="/myfavors" class="hrefitem">
                        <div class="linell">
                            <div>
                                <img src="@/images/scjl@3x.png" class="mvicon"/>
                            </div>
                            <div >
                                <div>我的收藏</div>
                                <img src="@/images/chevron@3x.png" class="access"/>
                            </div>
                        </div>
                    </router-link>
                    <router-link to="/mycontacts" class="hrefitem">
                        <div>
                            <div>
                                <img src="@/images/contact.png" class="mvicon"/>
                            </div>
                            <div >
                                <div>我的参赛卡</div>
                                <img src="@/images/chevron@3x.png" class="access"/>
                            </div>
                        </div>
                    </router-link>
                </div>
                <div class="hr"></div>

                <div class="page-container-margin">
                    
                    <router-link to="/bindphone" class="hrefitem">
                        <div class="linell">
                            <div>
                                <img src="@/images/phone.png" class="mvicon"/>
                            </div>
                            <div >
                                <div>绑定手机</div>
                                <img src="@/images/chevron@3x.png" class="access"/>
                            </div>
                        </div>
                    </router-link>
                    <div class="hrefitem" @click="clearCache">
                        <div class="linell">
                            <div>
                                <img src="@/images/clear.png" class="mvicon"/>
                            </div>
                            <div hover-class="activeview">
                                <div>清空缓存</div>
                                <img src="@/images/chevron@3x.png" class="access"/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>  
    </div>
</template>

<script>
    import './index.less'
    import {Dialog} from 'vant'
    import {clearStorage,setLastRouter} from '@/libs/utils'
    export default {
        name: 'home',
        filters:{

        },
        data() {
            return {
                url: ''
            }
        },
        props: {
            list: Object
        },
        methods:{
            clearCache(){
                Dialog.confirm({
                    title: '提示',
                    confirmButtonText:'继续',
                    message: '清除缓存后会重新登录,是否继续?'
                }).then(()=>{
                  clearStorage();
                  let ro = {name:'index'}
                  setLastRouter(ro)
                  this.$router.replace({name:'login'});
                }).catch(() => {
                  // on cancel
                })
            }
        },
        computed:{

        }
    }
</script>